export const SidebarCollapse = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M5.5 14.25L5.5 1.75C5.5 1.41848 5.36831 1.10054 5.13389 0.866118C4.89947 0.631697 4.58152 0.500001 4.25 0.500001L1.75 0.5C1.41848 0.5 1.10054 0.631696 0.866121 0.866116C0.6317 1.10054 0.500003 1.41848 0.500003 1.75L0.5 14.25C0.5 14.5815 0.631697 14.8995 0.866117 15.1339C1.10054 15.3683 1.41848 15.5 1.75 15.5L4.25 15.5C4.58152 15.5 4.89946 15.3683 5.13388 15.1339C5.3683 14.8995 5.5 14.5815 5.5 14.25ZM1.75 14.25L1.75 1.75L4.25 1.75L4.25 14.25L1.75 14.25Z"
        fill="#C6C6C6"
      />
      <path
        d="M13.1075 8.625L11.4913 10.2413L12.375 11.125L15.5 8L12.375 4.875L11.4913 5.75875L13.1075 7.375L9.25 7.375L9.25 0.500002L8 0.500002L8 15.5L9.25 15.5L9.25 8.625L13.1075 8.625Z"
        fill="#C6C6C6"
      />
    </svg>
  );
};
